<template>
  <div class="add-panel-basic">
    <Input
      label="Название панели"
      placeholder="Шлагбаум у корпуса 3"
      tooltip="Название будет отображаться в миниаппе Жителя"
      required
      clearable
      v-model="panelBasicData.name"
    />
    <Input
      label="SIP аккаунт"
      placeholder="ekb_ms70_p1"
      required
      clearable
      v-model="panelBasicData.sipAccount"
    />
  </div>
</template>

<script>
import Input from '../../Form/Input.vue'

export default {
  name: 'AddPanelBasic',
  components: {
    Input,
  },
  data() {
    return {
      panelBasicData: {
        name: '',
        sipAccount: '',
      },
    }
  },
  watch: {
    panelBasicData: {
      handler(newVal) {
        this.$store.dispatch('setPanelData', {
          key: 'basic',
          value: newVal,
        })
      },
      deep: true,
    },
  },
  mounted() {
    const storedData = this.$store.getters.panelData.basic
    if (storedData) {
      this.panelBasicData = { ...this.panelBasicData, ...storedData }
    }
  },
}
</script>

<style lang="css" scoped>
.add-panel-basic {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
</style>
